import React from "react";
import {v4 as uuidv4} from 'uuid';
import {Card, TextStyle, Button, Badge, ButtonGroup} from '@shopify/polaris';

/**
 * get the automation status from the date given
 * @param automationStatus
 * @returns {{variant: string, label: string}}
 */
const getAutomationStatus = (automationStatus) => {
    let status = {
        label: "Paused",
        variant: "critical",
    }
    if (automationStatus === 1) {
        status.label = "Active";
        status.variant = "success";
    }
    return status;
}

const AutomationLists = ({
  automations,
  onAddAutomation,
  onEditAutomation,
  onDeleteAutomation,
}) => {
  return (
    <div key={uuidv4()}>
      <Card title={<TextStyle variation="subdued">START</TextStyle>}>
        <Card.Section>
          <TextStyle variation="subdued">
            The Automation starts after a customer abandons a checkout with a
            VALID phone number. Checkouts without a valid phone number will be
            ignored.
          </TextStyle>
        </Card.Section>
      </Card>
      <div className="timeline-container">
        {automations.length > 0 &&
          automations.map((automation) => {
            if (automation.type !== "pre_order") {
              return null;
            }
            let automationStatus = getAutomationStatus(automation.status);
            return (
              <div className="timeline" key={uuidv4()}>
                <div className="hr-line" />
                <div className="timeline-content">
                  <Card
                    title={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <TextStyle variation="strong">
                            <img
                              width={14}
                              height={14}
                              alt=""
                              src="../../Assets/Others/time-left.svg"
                            />
                            &nbsp; Wait{" "}
                            <TextStyle variation="positive">
                              {automation.delay_unit} {automation.delay_type}
                            </TextStyle>{" "}
                            and then send &nbsp;
                            <Badge status={automationStatus.variant}>
                              {automationStatus.label}
                            </Badge>
                          </TextStyle>
                        </div>
                        <div>
                          <Button
                            onClick={() => {
                              onEditAutomation(automation.id);
                            }}
                          >
                            Edit
                          </Button>
                          &nbsp;
                          <Button>
                            <img
                              width={15}
                              height={15}
                              alt=""
                              src="../../Assets/Others/delete.svg"
                              onClick={() => {
                                onDeleteAutomation(automation.id);
                              }}
                            />
                          </Button>
                        </div>
                      </div>
                    }
                  >
                    <div></div>{" "}
                    <div className="top-border">
                      <Card.Section>
                        <div className="flex-row">
                          <div className="w-100p">
                            <p>{automation.message}</p>
                          </div>
                        </div>
                      </Card.Section>
                    </div>
                  </Card>
                </div>
              </div>
            );
          })}
        <div className="timeline">
          <div className="hr-line" />
          <div className="timeline-content">
            <Button primary onClick={onAddAutomation}>
              Add new template
            </Button>
          </div>
        </div>
      </div>
      <Card title={<TextStyle variation="subdued">END</TextStyle>}>
        <Card.Section>
          <TextStyle variation="subdued">
            The automation ends for a customer once he/she recovered the cart
            and completes successfully or when all messages have been sent.
          </TextStyle>
        </Card.Section>
      </Card>
      <br />
    </div>
  );
};

export default AutomationLists;
